import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-cancel-request',
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss'],
  standalone: false,
})
export class CancelRequestComponent {
  @Input() formGroup: UntypedFormGroup;
  @Output() submissionClick = new EventEmitter<any>();
  @Output() cancelClick = new EventEmitter<any>();
  fileTypes = ['pdf', 'jpg', 'jpeg', 'png', 'xlsx', 'csv', 'doc', 'docx'];

  onClickSubmit() {
    this.submissionClick.emit();
  }

  onClickCancel() {
    this.cancelClick.emit();
  }
}
